import { Injectable } from "@angular/core";
import { AppService } from "../../../../../../core/service/Base.Service";

@Injectable()
export class StudentguardianService extends AppService<any> {

    constructor() {
        super('SMStudentguardian');
    }

    async getSMStudentguardian() {

        const result = await this.get('');
        return result;
    }

    async getStudentGuardian(studentid) {

        const result = await this.get('StudentGuardain', [studentid]);

        return result;
    }

    async getStudentGuardianList(studentid) {

        const result = await this.get('StudentGuardains', [studentid]);

        return result;
    }
   
}


// WEBPACK FOOTER //
// ./src/app/shell/forms/school-management/transaction/studentguardianlist/studentguardian/studentguardian.service.ts